// USDA Hardiness Zones and State-Specific Lawn Care Data
// Based on USDA Plant Hardiness Zone Map and state extension service recommendations

export const hardinessZones = {
  // Zone 3a/3b - Northern areas
  '3a': {
    range: '-40°F to -35°F',
    grassTypes: ['Fine Fescue', 'Perennial Ryegrass (limited)', 'Cool-season mix'],
    growingSeason: 'May - September',
    dormancyPeriod: 'October - April',
    keyTimings: {
      lastFrost: 'Mid to late May',
      firstFrost: 'Mid to late September',
      soilTempFor50F: 'Late April to early May',
      fallOverseedWindow: 'Late July to mid-August'
    }
  },
  '3b': {
    range: '-35°F to -30°F',
    grassTypes: ['Fine Fescue', 'Perennial Ryegrass', 'Cool-season mix'],
    growingSeason: 'May - September',
    dormancyPeriod: 'October - April',
    keyTimings: {
      lastFrost: 'Early to mid May',
      firstFrost: 'Late September to early October',
      soilTempFor50F: 'Late April',
      fallOverseedWindow: 'Early to mid-August'
    }
  },

  // Zone 4a/4b - Upper Midwest, Northern New England
  '4a': {
    range: '-30°F to -25°F',
    grassTypes: ['Kentucky Bluegrass', 'Fine Fescue', 'Perennial Ryegrass'],
    growingSeason: 'April - October',
    dormancyPeriod: 'November - March',
    keyTimings: {
      lastFrost: 'Early May',
      firstFrost: 'Early to mid October',
      soilTempFor50F: 'Mid April',
      fallOverseedWindow: 'Mid-August to early September'
    }
  },
  '4b': {
    range: '-25°F to -20°F',
    grassTypes: ['Kentucky Bluegrass', 'Fine Fescue', 'Perennial Ryegrass', 'Tall Fescue'],
    growingSeason: 'April - October',
    dormancyPeriod: 'November - March',
    keyTimings: {
      lastFrost: 'Late April to early May',
      firstFrost: 'Mid to late October',
      soilTempFor50F: 'Early to mid April',
      fallOverseedWindow: 'Late August to early September'
    }
  },

  // Zone 5a/5b - New England, Great Lakes
  '5a': {
    range: '-20°F to -15°F',
    grassTypes: ['Kentucky Bluegrass', 'Perennial Ryegrass', 'Fine Fescue', 'Tall Fescue'],
    growingSeason: 'March - November',
    dormancyPeriod: 'December - February',
    keyTimings: {
      lastFrost: 'Mid to late April',
      firstFrost: 'Mid to late October',
      soilTempFor50F: 'Early April',
      fallOverseedWindow: 'Late August to mid-September'
    }
  },
  '5b': {
    range: '-15°F to -10°F',
    grassTypes: ['Kentucky Bluegrass', 'Perennial Ryegrass', 'Tall Fescue', 'Fine Fescue'],
    growingSeason: 'March - November',
    dormancyPeriod: 'December - February',
    keyTimings: {
      lastFrost: 'Early to mid April',
      firstFrost: 'Late October to early November',
      soilTempFor50F: 'Late March to early April',
      fallOverseedWindow: 'Early to mid-September'
    }
  },

  // Zone 6a/6b - Mid-Atlantic, Lower New England
  '6a': {
    range: '-10°F to -5°F',
    grassTypes: ['Tall Fescue', 'Kentucky Bluegrass', 'Perennial Ryegrass', 'Fine Fescue'],
    growingSeason: 'March - November',
    dormancyPeriod: 'December - February',
    keyTimings: {
      lastFrost: 'Early to mid April',
      firstFrost: 'Late October to mid November',
      soilTempFor50F: 'Late March',
      fallOverseedWindow: 'Early to mid-September'
    }
  },
  '6b': {
    range: '-5°F to 0°F',
    grassTypes: ['Tall Fescue', 'Kentucky Bluegrass', 'Perennial Ryegrass', 'Zoysia (limited)'],
    growingSeason: 'March - December',
    dormancyPeriod: 'January - February',
    keyTimings: {
      lastFrost: 'Mid to late March',
      firstFrost: 'Mid to late November',
      soilTempFor50F: 'Mid to late March',
      fallOverseedWindow: 'Mid-September to early October'
    }
  },

  // Zone 7a/7b - Mid-Atlantic, Upper South
  '7a': {
    range: '0°F to 5°F',
    grassTypes: ['Tall Fescue', 'Zoysia', 'Bermuda (limited)', 'Kentucky Bluegrass (limited)'],
    growingSeason: 'March - December',
    dormancyPeriod: 'January - February',
    keyTimings: {
      lastFrost: 'Early to mid March',
      firstFrost: 'Late November to early December',
      soilTempFor50F: 'Early to mid March',
      fallOverseedWindow: 'Mid-September to mid-October'
    }
  },
  '7b': {
    range: '5°F to 10°F',
    grassTypes: ['Tall Fescue', 'Zoysia', 'Bermuda', 'Centipede (limited)'],
    growingSeason: 'March - December',
    dormancyPeriod: 'January - February',
    keyTimings: {
      lastFrost: 'Late February to early March',
      firstFrost: 'Early to mid December',
      soilTempFor50F: 'Early March',
      fallOverseedWindow: 'Late September to mid-October'
    }
  },

  // Zone 8a/8b - Lower South, Pacific Northwest
  '8a': {
    range: '10°F to 15°F',
    grassTypes: ['Zoysia', 'Bermuda', 'Centipede', 'St. Augustine (limited)', 'Tall Fescue'],
    growingSeason: 'March - December',
    dormancyPeriod: 'January - February',
    keyTimings: {
      lastFrost: 'Mid to late February',
      firstFrost: 'Mid December',
      soilTempFor50F: 'Late February',
      fallOverseedWindow: 'October to November'
    }
  },
  '8b': {
    range: '15°F to 20°F',
    grassTypes: ['Bermuda', 'Zoysia', 'St. Augustine', 'Centipede', 'Bahia'],
    growingSeason: 'February - December',
    dormancyPeriod: 'January',
    keyTimings: {
      lastFrost: 'Early to mid February',
      firstFrost: 'Late December',
      soilTempFor50F: 'Mid February',
      fallOverseedWindow: 'October to November'
    }
  },

  // Zone 9a/9b - Deep South, Florida, Texas, California
  '9a': {
    range: '20°F to 25°F',
    grassTypes: ['Bermuda', 'St. Augustine', 'Zoysia', 'Centipede', 'Bahia'],
    growingSeason: 'Year-round',
    dormancyPeriod: 'Limited winter dormancy',
    keyTimings: {
      lastFrost: 'Late January to early February',
      firstFrost: 'Late December to January',
      soilTempFor50F: 'Early February',
      fallOverseedWindow: 'November to December'
    }
  },
  '9b': {
    range: '25°F to 30°F',
    grassTypes: ['St. Augustine', 'Bermuda', 'Zoysia', 'Bahia', 'Centipede'],
    growingSeason: 'Year-round',
    dormancyPeriod: 'Minimal winter slowdown',
    keyTimings: {
      lastFrost: 'Mid to late January',
      firstFrost: 'Rare',
      soilTempFor50F: 'Late January',
      fallOverseedWindow: 'November to December'
    }
  },

  // Zone 10a/10b - South Florida, Hawaii, South Texas
  '10a': {
    range: '30°F to 35°F',
    grassTypes: ['St. Augustine', 'Bermuda', 'Zoysia', 'Bahia', 'Seashore Paspalum'],
    growingSeason: 'Year-round',
    dormancyPeriod: 'None',
    keyTimings: {
      lastFrost: 'Rare',
      firstFrost: 'Rare',
      soilTempFor50F: 'Year-round above 50°F',
      fallOverseedWindow: 'December to January'
    }
  },
  '10b': {
    range: '35°F to 40°F',
    grassTypes: ['St. Augustine', 'Seashore Paspalum', 'Bermuda', 'Zoysia'],
    growingSeason: 'Year-round',
    dormancyPeriod: 'None',
    keyTimings: {
      lastFrost: 'Never',
      firstFrost: 'Never',
      soilTempFor50F: 'Year-round above 50°F',
      fallOverseedWindow: 'December to January'
    }
  }
};

// State to Hardiness Zone Mapping (primary zones)
export const stateZoneMapping = {
  'Alabama': ['7a', '7b', '8a', '8b'],
  'Alaska': ['3a', '3b', '4a', '4b', '5a', '6a', '7a'],
  'Arizona': ['4b', '5a', '6a', '7a', '8a', '8b', '9a', '9b', '10a'],
  'Arkansas': ['6b', '7a', '7b', '8a'],
  'California': ['5a', '6a', '7a', '8a', '8b', '9a', '9b', '10a', '10b'],
  'Colorado': ['3a', '3b', '4a', '4b', '5a', '5b', '6a', '6b', '7a'],
  'Connecticut': ['5b', '6a', '6b'],
  'Delaware': ['6b', '7a'],
  'Florida': ['8b', '9a', '9b', '10a', '10b'],
  'Georgia': ['7a', '7b', '8a', '8b'],
  'Hawaii': ['10a', '10b'],
  'Idaho': ['3a', '3b', '4a', '4b', '5a', '5b', '6a', '6b', '7a'],
  'Illinois': ['5a', '5b', '6a', '6b'],
  'Indiana': ['5a', '5b', '6a', '6b'],
  'Iowa': ['4b', '5a', '5b'],
  'Kansas': ['5b', '6a', '6b', '7a'],
  'Kentucky': ['6a', '6b', '7a'],
  'Louisiana': ['8a', '8b', '9a'],
  'Maine': ['3b', '4a', '4b', '5a', '5b'],
  'Maryland': ['6a', '6b', '7a'],
  'Massachusetts': ['5a', '5b', '6a', '6b'],
  'Michigan': ['3b', '4a', '4b', '5a', '5b', '6a'],
  'Minnesota': ['3a', '3b', '4a', '4b'],
  'Mississippi': ['7b', '8a', '8b', '9a'],
  'Missouri': ['5b', '6a', '6b', '7a'],
  'Montana': ['3a', '3b', '4a', '4b', '5a', '5b'],
  'Nebraska': ['4b', '5a', '5b'],
  'Nevada': ['4b', '5a', '6a', '7a', '8a', '9a'],
  'New Hampshire': ['3b', '4a', '4b', '5a', '5b'],
  'New Jersey': ['6a', '6b', '7a'],
  'New Mexico': ['4b', '5a', '6a', '7a', '8a'],
  'New York': ['3b', '4a', '4b', '5a', '5b', '6a', '6b'],
  'North Carolina': ['6a', '6b', '7a', '7b', '8a'],
  'North Dakota': ['3a', '3b', '4a'],
  'Ohio': ['5a', '5b', '6a', '6b'],
  'Oklahoma': ['6a', '6b', '7a', '7b'],
  'Oregon': ['4b', '5a', '6a', '7a', '8a', '8b', '9a'],
  'Pennsylvania': ['5a', '5b', '6a', '6b'],
  'Rhode Island': ['6a', '6b'],
  'South Carolina': ['7b', '8a', '8b'],
  'South Dakota': ['3b', '4a', '4b', '5a'],
  'Tennessee': ['6a', '6b', '7a', '7b'],
  'Texas': ['6b', '7a', '7b', '8a', '8b', '9a', '9b'],
  'Utah': ['4a', '4b', '5a', '5b', '6a', '7a'],
  'Vermont': ['3b', '4a', '4b', '5a'],
  'Virginia': ['5b', '6a', '6b', '7a'],
  'Washington': ['4b', '5a', '6a', '7a', '8a', '8b', '9a'],
  'West Virginia': ['5a', '5b', '6a', '6b'],
  'Wisconsin': ['3b', '4a', '4b', '5a'],
  'Wyoming': ['3a', '3b', '4a', '4b', '5a']
};

// Get primary zone for a state (most common zone)
export const getStateDefaultZone = (state) => {
  const zones = stateZoneMapping[state];
  if (!zones || zones.length === 0) return '6a';
  
  // Return the middle zone as default
  return zones[Math.floor(zones.length / 2)];
};

// Get zone-specific lawn care adjustments
export const getZoneAdjustments = (zone) => {
  const zoneData = hardinessZones[zone];
  if (!zoneData) return {};
  
  return {
    grassTypes: zoneData.grassTypes,
    growingSeason: zoneData.growingSeason,
    keyTimings: zoneData.keyTimings,
    dormancyPeriod: zoneData.dormancyPeriod
  };
};